function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import clsx from 'clsx';
import { string } from 'prop-types';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
const StyledContent = styled(CardContent)(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    padding: spacing(2),
    '&:last-child': {
      paddingBottom: spacing(2)
    }
  };
});

/**
 * To definte the content section of the card, encapsulate its content
 * within a `SovosCardContent` component.
 *
 * **Note** Must be a child of `SovosCard`
 */
const SovosCardContent = _ref2 => {
  let {
    className,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledContent, _extends({
    className: clsx('sovosCardContent', className)
  }, rest));
};
SovosCardContent.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosCardContent.baseComponent = {
  name: 'Card Content',
  link: 'card-content/'
};
export default SovosCardContent;